module.exports = __webpack_public_path__ + "img/wp-existing-habit-card14.8132a95b.jpg";